import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, from, until } from '@helpers/media';
import { Typography } from '@stories/Elements/Typography/Typography.styles';
import styled, { css } from 'styled-components';

const Card = styled.div<{ showBorder: boolean }>`
  position: relative;
  border-radius: 4px;
  border-top: ${({ showBorder }) => (showBorder ? `5px solid ${brand.red.base}` : `5px solid ${brand.white}`)};
  overflow: hidden;
  --textColour: ${brand.white};

  &[data-theme='0'] {
    --textColour: ${brand.black};
  }

  &[data-theme='1'] {
    --textColour: ${brand.white};
  }

  &[data-theme='2'] {
    --textColour: ${brand.red.base};
  }
`;

const Inner = styled.div`
  position: relative;
  z-index: 1;
  padding: 32px 6px 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  @media ${from(Device.MobileLarge)} {
    padding: 36px 12px 16px;
  }

  @media ${from(Device.TabletLarge)} {
    padding: 40px 24px 20px 24px;
  }
`;

const backgroundStyles = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
`;

const Background = styled.img`
  ${backgroundStyles};
`;

const BackgroundVideo = styled.video`
  ${backgroundStyles};
`;

const Title = styled.h2<{ isLongText: boolean }>`
  color: var(--textColour);
  padding: 40px 0px;
  text-align: center;
  ${Typography.H4Style};

  @media ${until(Device.MobileLarge)} {
    font-size: 16px;
    line-height: 17px;
  }

  ${({ isLongText }) =>
    isLongText &&
    css`
      @media ${until(Device.DesktopSmall)} {
        font-size: 11px;
        line-height: 15px;
        word-break: break-word;
      }

      @media ${from(Device.DesktopSmall)} {
        font-size: 15px;
        line-height: 18px;
      }

      @media ${from(Device.DesktopLarge)} {
        font-size: 16px;
        line-height: 18px;
      }
    `}
`;

const Tag = styled.div`
  position: absolute;
  top: -1px;
  left: 50%;
  transform: translateX(-50%);
  ${fonts.helvetica['73-bold-extended']};
  display: block;
  padding: 4px 8px;
  font-size: 14px;
  line-height: 1.2;
  background-color: ${brand.red.base};
  color: ${brand.white};
  text-transform: uppercase !important;
  letter-spacing: ${fonts.ls(10)};

  @media ${from(Device.Tablet)} {
    font-size: 16px;
  }
`;

export const PromoCardStyles = {
  Card,
  Title,
  Background,
  BackgroundVideo,
  Inner,
  Tag,
};
